"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var attachmentsSubCategory_1 = require("./attachmentsSubCategory");
var automationSubCategory_1 = require("./automationSubCategory");
var blockAllowSubCategory_1 = require("./blockAllowSubCategory");
var handlingSubCategory_1 = require("./handlingSubCategory");
var layoutSubCategory_1 = require("./layoutSubCategory");
var messageContentSubcategory_1 = require("./messageContentSubcategory");
var rulesSubCategory_1 = require("./rulesSubCategory");
var surfaceActionsSubcategory_1 = require("./surfaceActionsSubcategory");
var mailCategory = {
    key: 'mail',
    titleStringKey: 'optionCategory_Mail',
    icon: "Mail" /* Mail */,
    subcategories: [
        layoutSubCategory_1.default,
        automationSubCategory_1.default,
        handlingSubCategory_1.default,
        attachmentsSubCategory_1.default,
        messageContentSubcategory_1.default,
        blockAllowSubCategory_1.default,
        rulesSubCategory_1.default,
        surfaceActionsSubcategory_1.default,
    ],
};
exports.default = mailCategory;
//# sourceMappingURL=category.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/config/mail/owa-options-mail/lib/data/category.js
// module id = 4977
// module chunks = 2